import React, { forwardRef } from 'react';
import classNames from 'classnames';
import BaseButton from '../BaseButton';
import { IconButtonProps } from './types';
import classes from './index.module.scss';

const IconButton = forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonProps>(
  (
    {
      intent = 'secondary',
      variant = 'filled',
      size = 'md',
      loading = false,
      shape = 'square',
      children,
      className: customClassName,
      ...rest
    },
    ref
  ) => {
    const className = classNames(
      classes[`icon-button-size-${size}`],
      classes[`shape-${shape}-${size}`],
      customClassName
    );

    return (
      <BaseButton
        ref={ref}
        className={className}
        shape={shape}
        loading={loading}
        intent={intent}
        variant={variant}
        {...rest}
      >
        {children}
      </BaseButton>
    );
  }
);

IconButton.displayName = 'IconButton';

export default IconButton;
